import CloseIcon from "@mui/icons-material/Close";
import {
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    IconButton,
    Paper,
    Step,
    StepLabel,
    Stepper,
    TextField,
    Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import toast from 'react-hot-toast';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";

const ConcreteCastingRegistrationAdd = () => {
  const authContext = React.useContext(AuthContext);
  const navigate = useNavigate()
  const {id} = useParams()
  const [activeStep, setActiveStep] = useState(0)
  const [formData, setFormData] = useState({
    name: "",
    processing_name: "",
    mq2_of_casting: "",
    concrete_type: "",
    concrete_dl_withdrawal_report: "",
    number_of_cubes: 1,
    cubes: [{ cubes_identification: "" }],
  })
  const [fieldErrors, setFieldErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [reportOptions, setReportOptions] = useState([])

  useEffect(() => {
    if (id) {
      apiService
        .get("/concrete-casting-registration-managment/" , {id: id}, {} )
        .then((response) => {
          debugger
          if (response) {
            setFormData(response)
          }
        })
        .catch((error) => {
          handleSetNotification('Errore durante la chiamata al server, codice d\'errore #08514262429906', 'error');
        })
    }
  }, [id])

  const handleSetNotification = (msg, severityType) => {
    if (severityType === 'success') {
      toast.success(msg, {id: 'concrete-casting-registration-add-toast'});
    } else {
      toast.error(msg, {id: 'concrete-casting-registration-add-toast'});
    }
  }

  function getReportOptions() {
    apiService.get("/concrete-dl-withdrawal-report-managment/get-option/", {id_area: localStorage.getItem("areaSelected")}, {} )
      .then((response) => {
        if (response)
          setReportOptions(response)
      })
      .catch((error) => {
        handleSetNotification('Errore durante la chiamata al server, codice d\'errore #08514262429906', 'error');
      })
  }

  useEffect(() => {
    getReportOptions()
  }, []);

   const handleInputChange = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }))
    setFieldErrors((prevErrors) => ({ ...prevErrors, [name]: false }))

    if (name === "number_of_cubes") {
      updateCubesArray(value)
    }
  }

  const updateCubesArray = (newNumberOfCubes) => {
    setFormData((prevData) => {
      const currentCubes = [...prevData.cubes]
      if (newNumberOfCubes === "" || isNaN(newNumberOfCubes)) {
        // Keep existing cubes in memory, but don't display them
        return { ...prevData, number_of_cubes: newNumberOfCubes }
      } else {
        const numCubes = Number.parseInt(newNumberOfCubes, 10)
        if (numCubes > currentCubes.length) {
          // Add new cubes
          const newCubes = Array(numCubes - currentCubes.length)
            .fill()
            .map(() => ({ cubes_identification: "" }))
          return {
            ...prevData,
            number_of_cubes: numCubes,
            cubes: [...currentCubes, ...newCubes],
          }
        } else if (numCubes < currentCubes.length) {
          // Remove excess cubes
          return {
            ...prevData,
            number_of_cubes: numCubes,
            cubes: currentCubes.slice(0, numCubes),
          }
        }
        // If the number is the same, no change is needed
        return { ...prevData, number_of_cubes: numCubes }
      }
    })
  }

  const handleCubeInputChange = (index, value) => {
    const newCubes = [...formData.cubes]
    newCubes[index] = { cubes_identification: value }
    setFormData((prevData) => ({ ...prevData, cubes: newCubes }))
  }

  const validateStep = (step) => {
    const errors = {}
    if (step === 0) {
      if (!formData.name) errors.name = true
      if (!formData.processing_name) errors.processing_name = true
      if (!formData.mq2_of_casting) errors.mq2_of_casting = true
      if (!formData.concrete_type) errors.concrete_type = true
      if (!formData.concrete_dl_withdrawal_report) errors.concrete_dl_withdrawal_report = true
    } else if (step === 1) {
      if (!formData.number_of_cubes || formData.number_of_cubes < 1) errors.number_of_cubes = true
      formData.cubes.forEach((cube, index) => {
        if (!cube.cubes_identification) errors[`cube_${index}`] = true
      })
    }
    setFieldErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleNext = () => {
    if (validateStep(activeStep)) {
      setActiveStep((prevStep) => prevStep + 1)
    } else {
      const errorFields = Object.keys(fieldErrors).join(", ")
      handleSetNotification(`Compila tutti i campi prima di procedere`, "error")
    }
  }

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1)
  }

  const handleSubmit = async () => {
    if (validateStep(1)) {
      setLoading(true)
      try {
        await apiService.post(
          "/concrete-casting-registration-managment/",
          {},
          formData,
        )
        handleSetNotification("Verbale creato con successo", "success")
        navigate("/concrete-casting-registration-managment")
      } catch (error) {
        handleSetNotification("Errore durante la chiamata al server, codice d'errore #08514262429906", "error")
      } finally {
        setLoading(false)
      }
    } else {
      const errorFields = Object.keys(fieldErrors).join(", ")
      handleSetNotification(`Compila tutti i campi prima di procedere`, "error")
    }
  }

  const handleRemoveCube = (indexToRemove) => {
    setFormData((prevData) => ({
      ...prevData,
      number_of_cubes: prevData.number_of_cubes - 1,
      cubes: prevData.cubes.filter((_, index) => index !== indexToRemove),
    }))
  }

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <>
             <TextField
              fullWidth
              label="Nome getto"
              name="name"
              value={formData.name}
              onChange={(e) => handleInputChange("name", e.target.value)}
              required
              error={fieldErrors.name}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Nome lavorazione"
              name="processing_name"
              value={formData.processing_name}
              onChange={(e) => handleInputChange("processing_name", e.target.value)}
              required
              error={fieldErrors.processing_name}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="MQ2 di getto"
              name="mq2_of_casting"
              type="number"
              value={formData.mq2_of_casting}
              onChange={(e) => handleInputChange("mq2_of_casting", e.target.value)}
              required
              error={fieldErrors.mq2_of_casting}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Tipologia calcestruzzo"
              name="concrete_type"
              value={formData.concrete_type}
              onChange={(e) => handleInputChange("concrete_type", e.target.value)}
              required
              error={fieldErrors.concrete_type}
              sx={{ mb: 2 }}
            />
            <Autocomplete
              fullWidth
              options={reportOptions} // Replace with actual options
              getOptionLabel={(option) => option?.name || "Seleziona un report di prelievo"}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Concrete DL Withdrawal Report"
                  required
                  error={fieldErrors.concrete_dl_withdrawal_report}
                />
              )}
              value={formData.concrete_dl_withdrawal_report}
              onChange={(_, newValue) => handleInputChange("concrete_dl_withdrawal_report", newValue)}
              sx={{ mb: 2 }}
            />
          </>
        )
      case 1:
        return (
          <>
            <TextField
              fullWidth
              label="Numero di cubi"
              name="number_of_cubes"
              type="number"
              value={formData.number_of_cubes}
              onChange={(e) => handleInputChange("number_of_cubes", e.target.value)}
              required
              error={fieldErrors.number_of_cubes}
              sx={{ mb: 2 }}
            />
            {formData.number_of_cubes !== "" &&
              !isNaN(formData.number_of_cubes) &&
              formData.cubes.slice(0, formData.number_of_cubes).map((cube, index) => (
                <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <TextField
                    fullWidth
                    label={`Identificazione cubo (${index + 1})`}
                    value={cube.cubes_identification}
                    onChange={(e) => handleCubeInputChange(index, e.target.value)}
                    required
                    error={fieldErrors[`cube_${index}`]}
                  />
                  <IconButton
                    onClick={() => handleRemoveCube(index)}
                    sx={{ ml: 1 }}
                    aria-label={`Rimuovi cubo ${index + 1}`}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              ))}
          </>
        )
      default:
        return null
    }
  }

  return (
  <DashboardLayout>
    {authContext?.hasAuth("UPDATE_CONCRETECASTINGREGISTRATION") ? (
      <>
        <DashboardNavbar />
        {!loading ? (
          <Paper elevation={3} sx={{p: 3, maxWidth: 900, mx: "auto", mt: 4}}>
            <center>
               <Typography variant="h5" gutterBottom>
                Registrazione getto calcestruzzo
              </Typography>
              <Button
                variant="contained"
                onClick={() => navigate("/concrete-casting-registration-managment")}
                sx={{
                  mb:3,
                  color: "white!important",
                }}
              >
                TORNA ALLA TABELLA
              </Button>
            </center>
            <Stepper activeStep={activeStep} sx={{mb: 4}}>
              <Step>
                <StepLabel>Informazioni generali</StepLabel>
              </Step>
              <Step>
                <StepLabel>Cubi prelevati</StepLabel>
              </Step>
            </Stepper>
            <Box component="form" noValidate autoComplete="off">
              {renderStepContent(activeStep)}
              <Box sx={{display: "flex", justifyContent: "space-between", mt: 2}}>
                <Button onClick={handleBack} disabled={activeStep === 0} sx={{color: "white!important"}}>
                  Indietro
                </Button>
                {activeStep === 1 ? (
                  <Button variant="contained" onClick={handleSubmit} sx={{color: "white!important"}}>
                    Salva
                  </Button>
                ) : (
                  <Button variant="contained" onClick={handleNext} sx={{color: "white!important"}}>
                    Avanti
                  </Button>
                )}
              </Box>
            </Box>
          </Paper>
        ) : (
          <Box sx={{display: "flex", justifyContent: "center", mt: 4}}>
            <CircularProgress size={120} sx={{color: "#2b84ea"}}/>
          </Box>
        )}
      </>
    ) : (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Typography variant="h6">
          Non hai il permesso di modificare questa registrazione
        </Typography>
      </Box>
    )}
  </DashboardLayout>
);

}

export default ConcreteCastingRegistrationAdd
